module.exports = __webpack_public_path__ + "img/P14-zh.024513c8.png";